export default [
    {
        path: "/pros/tasks",
        exact: true,
        policy: "providerAuth",
        component: "Tasks",
        mui: true,
    },
];